export enum DragSide {
  left = 1,
  right,
  top,
  bottom,
}

export const calculateDragSide = (x: number, y: number, w: number, h: number): DragSide => {
  const r = h/w;
  if (x < w/2) {
    if (y < h/2 && y < r*x) return DragSide.top;
    if (y > h/2 && y > h - r*x) return DragSide.bottom;
    return DragSide.left;
  }
  if (y < h/2 && y < h - r*x) return DragSide.top;
  if (y > h/2 && y > r*x) return DragSide.bottom;
  return DragSide.right;
}

export const segmIntersect = (a: number, alen: number, b: number, blen: number): number =>
  a >= b
    ? Math.min(alen, b + blen - a)
    : Math.min(blen, a + alen - b);

export const enoughIntersect = (a: number, alen: number, b: number, blen: number, percent: number): boolean =>
  segmIntersect(a, alen, b, blen) > percent*(alen + blen)/2;

export const segmEnough = (alen: number, blen: number, percent: number, segm: number): boolean =>
  segm > percent*(alen + blen)/2;

export const hasIntersect = (a: number, alen: number, b: number, blen: number): boolean =>
  segmIntersect(a, alen, b, blen) > 0;